<template>
  <div class="modal fade" id="businessFormModal" tabindex="-1" aria-labelledby="businessFormModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="businessFormModalLabel">Empresa</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <v-form
          ref="modalForm"
          @submit="store"
          :validation-schema="formSchema"
          :initial-values="formValues"
          v-slot="{ errors }"
        >
          <div class="modal-body">
            <div class="mb-3">
              <label for="nameInput" class="form-label">Nombre</label>

              <v-field
                name="nombre"
                as="input"
                type="text"
                id="nameInput"
                class="form-control"
              />

              <span class="fs-6 text-danger">{{ errors.nombre }}</span>
            </div>

            <div class="mb-3">
              <label for="orgIdInput" class="form-label">Organización Id</label>

              <v-field
                name="org_id"
                as="input"
                type="number"
                id="orgIdInput"
                class="form-control"
              />

              <span class="fs-6 text-danger">{{ errors.org_id }}</span>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>

            <button class="btn btn-primary">
              Guardar
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </div>

  <toast :config="alert"></toast>
</template>

<script>
// @ is an alias to /src
import APIBusiness from '@/api/business';
import { Form as VForm, Field as VField } from 'vee-validate';
import { setLocale } from 'yup';
import * as yup from 'yup';
import { reactive, watchEffect, getCurrentInstance } from 'vue';
import $ from 'jquery'

setLocale({
  mixed: {
    required: 'El campo es requerido',
  },
});

export default {
  props: {
    form: Object,
  },

  components: {
    VField,
    VForm,
  },

  emits: ['store'],

  setup(props, { emit }) {
    const internalInstance = getCurrentInstance()

    const alert = reactive({
      message: "",
      title: "",
    })

    const formSchema = {
      nombre: yup.string().required(),
      org_id: yup.number().required().positive().integer(),
    }

    const formValues = reactive({
      id: '',
      nombre: '',
      org_id: null,
    })

    function store(values) {
      props.form.ID ? update(props.form.ID, values) : save(values);
    }

    function save(values) {
      values.org_id = parseInt(values.org_id);

      APIBusiness.post(values)
        .then(() => {
          $('#businessFormModal').modal('hide');
          emit('store');
        })
        .catch((error) => {
          alert.title = "Error al crear";
          alert.message = error.response ? error.response.data.msg : 'Error en la petición';
          $('#toast').toast('show');
        });
    }

    function update(id, values) {
      values.org_id = parseInt(values.org_id);

      APIBusiness.patch(id, values)
        .then(() => {
          $('#businessFormModal').modal('hide');
          emit('store');
        })
        .catch((error) => {
          alert.title = "Error al actualizar";
          alert.message = error.response ? error.response.data.msg : 'Error en la petición';
          $('#toast').toast('show');
        });
    }

    watchEffect(() => {
      if (internalInstance.refs.modalForm) {
        internalInstance.refs.modalForm.resetForm()
      }

      if (props.form.ID != undefined) {
        formValues.id = props.form.ID;
        formValues.nombre = props.form.Nombre;
        formValues.org_id = parseInt(props.form.OracleID);
      } else {
        formValues.id = '';
        formValues.nombre = '';
        formValues.org_id = null;
      }
    })

    return {
      alert,
      formSchema,
      formValues,
      store,
      save,
      update,
      internalInstance,
    }
  }
}
</script>
